<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="widgetMasterData"
		selection
		:excel="true"
		paging
		@changedPage="onChangePage"
		:pageUnit="pagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="pagingInfo.totalSize"
	>
		<template v-slot:actionsLeft>
			<sf-button line icon="square-plus" v-if="isButton_(scrId, 'AD')" :onClick="addRow_">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
			<sf-button line icon="file" v-if="isButton_(scrId, 'AD')" :onClick="() => onClick('save')">{{ getMessage_('SWCC000138') }}</sf-button>
			<sf-button line icon="trash" v-if="isButton_(scrId, 'CD')" :onClick="() => onClick('delete')" color="error">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>
<script>
import * as yup from 'yup';
import { serviceComputed, serviceMethods } from '@common/WidgetMaster/store/helpers';
import { rootComputed } from '@/store/common/helpers';

export default {
	computed: {
		...rootComputed,
		...serviceComputed,
		widgetMasterData() {
			return this.rows; //.map((row) => this.schema.cast(row));
		},
		options() {
			return this.useYnOptions.map(({ value }) => ({ value, label: value }));
		},
		schema() {
			return yup.object().shape({
				widgetTitle: yup
					.string()
					.trim()
					.default(() => '')
					.required(this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000224')]))
					.min(1, this.$sf_formatString(this.getMessage_('SWCC000176'), [this.getMessage_('SWCC000224'), 1]))
					.max(100, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000224'), 20])),
				parameter: yup
					.string()
					.trim()
					.default(() => '')
					.max(500, this.$sf_formatString(this.getMessage_('SWCC000177'), [this.getMessage_('SWCC000228'), 20])),
				minWidth: yup
					.string()
					.trim()
					.default(() => '')
					.matches(/^[0-9]*$/), //, this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000225')])
				minHeight: yup
					.string()
					.trim()
					.default(() => '')
					.matches(/^[0-9]*$/) //, this.$sf_formatString(this.getMessage_('SWCC000175'), [this.getMessage_('SWCC000226')])
			});
		},
		columns() {
			return [
				{ label: 'No', prop: 'rnum', width: '120' },
				{ label: this.getMessage_('SWCC000141'), prop: 'status', minWidth: '140' },
				{ label: this.getMessage_('SWCC000230'), prop: 'widgetKey', minWidth: '200' },
				{
					label: this.getMessage_('SWCC000733'),
					prop: 'widgetMstFileId',
					minWidth: '200',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('SWCC000224'),
					prop: 'widgetTitle',
					minWidth: '240',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('SWCC000225'),
					prop: 'minW',
					minWidth: '200',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('SWCC000226'),
					prop: 'minH',
					minWidth: '200',
					form: {
						type: 'input',
						maxLength: 20
					}
				},
				{
					label: this.getMessage_('SWCC000227'),
					prop: 'resizeYn',
					minWidth: '200',
					form: {
						type: 'select',
						options: this.useYnOptions
					}
				},
				{
					label: this.getMessage_('SWCC000228'),
					prop: 'parameter',
					minWidth: '500',
					form: {
						type: 'input',
						maxLength: 500
					}
				},
				{
					label: this.getMessage_('SWCC000145'),
					prop: 'useYn',
					minWidth: '200',
					form: {
						type: 'select',
						options: this.useYnOptions
					}
				},
				{ label: this.getMessage_('SWCC000229'), prop: 'cnt', minWidth: '200' },
				{ label: this.getMessage_('SWCC000005'), prop: 'regId', minWidth: '200' },
				{ label: this.getMessage_('SWCC000146'), prop: 'regDt', minWidth: '250' },
				{ label: this.getMessage_('SWCC000172'), prop: 'chgId', minWidth: '200' },
				{ label: this.getMessage_('SWCC000171'), prop: 'chgDt', minWidth: '250' }
			];
		}
	},
	methods: {
		...serviceMethods,
		isAdded: ({ row }) => row.status !== 'I',
		async onClick(action) {
			const selectedRows = this.getSelectedRows();
			if (!selectedRows || selectedRows.length === 0) {
				return;
			}
			const messageCode = {
				save: 'SWCC000501',
				delete: 'SWCC000108'
			}[action];
			const clickFn = {
				save: this.onClickSave,
				delete: this.onClickDelete
			}[action];
			await this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message: this.getMessage_(messageCode),
				buttons: [{ title: 'Confirm', clickFn }] //this.getMessage_('SWCC000203')
			});
		},
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.selectWidgetMaster_({ currentPage: currentPageVal, pageUnit: pageUnitVal }).finally(() => this.$sf_toggleLoading(false));
		},
		getSelectedRows() {
			return this.$refs.table.getSelectedRows().map(r => this.schema.cast(_.omitBy(r, _.isNil)));
		},
		async onClickSave() {
			const rows = this.getSelectedRows();
			const fail = (
				await Promise.all(
					rows.map(row =>
						this.schema
							.validate(row)
							.then(() => ({ isValid: true }))
							.catch(e => ({ isValid: false, ...e }))
					)
				)
			).filter(r => !r.isValid);
			if (fail.length > 0) {
				this.$sf_showMessage({ icon: 'error', message: fail[0].message });
				return;
			}
			this.$sf_toggleLoading(true);
			return this.save_(rows)
				.then(r => this.$sf_toast(r))
				.finally(() => this.$sf_toggleLoading(false));
		},
		onClickDelete() {
			let selectedRows = this.getSelectedRows();
			const removeKeys = selectedRows.filter(r => r.status === 'I').map(r => r.rowKey);
			const deleteRows = selectedRows.filter(r => r.status !== 'I');
			this.removeRows_(removeKeys).then(r => {
				if (_.isEmpty(deleteRows)) {
					return;
				}
				this.$sf_toggleLoading(true);
				return this.delete_(deleteRows)
					.then(r => this.$sf_toast(r))
					.finally(() => this.$sf_toggleLoading(false));
			});
		}
	}
};
</script>
